__turbopack_context__.v({
  "commonTable": "commonTableDesktop-module-scss-module__a-dtNW__commonTable",
  "cta": "commonTableDesktop-module-scss-module__a-dtNW__cta",
  "ctaWrapper": "commonTableDesktop-module-scss-module__a-dtNW__ctaWrapper",
  "description": "commonTableDesktop-module-scss-module__a-dtNW__description",
  "tableContainer": "commonTableDesktop-module-scss-module__a-dtNW__tableContainer",
  "title": "commonTableDesktop-module-scss-module__a-dtNW__title",
});
